export default "__VITE_ASSET__DXvuZ$gX__"